import { render, staticRenderFns } from "./user-wallet.vue?vue&type=template&id=d089d14c&scoped=true"
import script from "./user-wallet.vue?vue&type=script&lang=js"
export * from "./user-wallet.vue?vue&type=script&lang=js"
import style0 from "./user-wallet.vue?vue&type=style&index=0&id=d089d14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d089d14c",
  null
  
)

export default component.exports